import React, { useEffect } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import { useParams, useHistory } from 'react-router-dom'
import { EndingPage, MidPages } from './components'
import { useSelector, useDispatch } from 'react-redux'
import { getCardAction } from 'src/reducers/card/action'
import EmptyMiniCourse from './components/empty-mini-course'
import {
  LandingPageEditor,
  LandingPagePreviewMain,
} from 'src/components/landing-page'
import { SectionTypes } from 'src/model/card'

const CardView = props => {
  const { sections, setSections } = props
  const { page, subPage } = useParams()
  const history = useHistory()
  const course = useSelector(state => state.course.course)
  const dispatch = useDispatch()

  useEffect(() => {
    if (page === 'page' && subPage === undefined) {
      //TODO bence madde gelince yapilacak, last cardla degisim oldugunda en son karttan baslasin diyecekler :D

      if (sections?.length > 0 && sections[0]?.cards?.length > 0) {
        history.push(
          '/mini-course/' + course.id + '/page/' + sections[0].cards[0].id,
        )
        dispatch(getCardAction(sections[0].cards[0].id))
      } else {
        dispatch(getCardAction(null))
      }
    }
  }, [sections, page, subPage])

  switch (page) {
    case 'landing-page':
      if (subPage) {
        return (
          <LandingPageEditor sections={sections} setSections={setSections} />
        )
      }
      return (
        <LandingPagePreviewMain sections={sections} setSections={setSections} />
      )
    case 'completion':
      return <EndingPage sections={sections} setSections={setSections} />
    default:
      if (!course || !course.sections) {
        return null
      }

      // Changed condition: Check if there are any non-ENDING sections
      const hasNonEndingSections = sections.some(
        section => section.type !== SectionTypes.ENDING,
      )
      const sectionHasCards = sections.some(section => section.cards.length > 0)
      if (hasNonEndingSections && sectionHasCards) {
        return <MidPages sections={sections} setSections={setSections} />
      } else {
        return <EmptyMiniCourse sections={sections} setSections={setSections} />
      }
  }
}

export default withStyles(styles)(CardView)
